import { useCallback, useEffect, useState } from "react";

function useMultiDisclosure<T extends string | number>(sessionIds: T[]) {
  const [disclosures, setDisclosures] = useState<Record<T, boolean>>(
    {} as Record<T, boolean>,
  );

  // Sync with new session IDs
  useEffect(() => {
    setDisclosures((prev) => {
      const newDisclosures: Record<T, boolean> = {} as Record<T, boolean>;

      // Preserve existing open states, initialize new ones
      sessionIds.forEach((id) => {
        newDisclosures[id] = prev[id] ?? false;
      });

      return newDisclosures;
    });
  }, [sessionIds]);

  const open = useCallback((id: T) => {
    setDisclosures((prev) => ({ ...prev, [id]: true }));
  }, []);

  const close = useCallback((id: T) => {
    setDisclosures((prev) => ({ ...prev, [id]: false }));
  }, []);

  const toggle = useCallback((id: T) => {
    setDisclosures((prev) => ({ ...prev, [id]: !prev[id] }));
  }, []);

  return { disclosures, open, close, toggle };
}

export default useMultiDisclosure;
